import { render, staticRenderFns } from "./payments-modal.vue?vue&type=template&id=a40f3cc8"
import script from "./payments-modal.vue?vue&type=script&lang=js"
export * from "./payments-modal.vue?vue&type=script&lang=js"
import style0 from "./payments-modal.vue?vue&type=style&index=0&id=a40f3cc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports